import React, { useEffect, useState } from 'react';
import UpSell from '@components/upSell';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { upsellCheck, setSeat } from '@reducers/orders';
import { APP_CONFIG } from '@constants';
import { setNotification } from '@reducers/notification';
import { getObjectValue } from '@utility/utills';
import Loader from '@components/common/Loader/index';

const KioskUpsell = (props) => {

  // Props Destructuring

  const {seat, deviceInfo, userInfo, upsellCheck, setSeat, check, setNotification,  } = props;

  // State Management

  const [isUpsell, setIsUpsell] = useState(false);

  // React Hooks

  useEffect(() => {
    getUpsellItems();
  }, []);

  // Methods

  const goToCart = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/kiosk/cart`, {replace: true});
  };

  const getUpsellItems = () => {
    const data = getObjectValue(() => seat.orders[0].items.reduce((a, v) => {
      if (v.pending) {
        a.push({
          ...v,
          ...JSON.parse(v.orderJson),
          menuScreenId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuScreenId), 0),
          menuId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuId), 0)
        });
      }
      return a;
    }, []), []);
    let subtotalAmount = 0;
    const items = data && data.length > 0 ? data.map((e) => {
      subtotalAmount += e.price;
      return {
        menuItemId: e.menuItemId,
        quantity: e.quantity,
        modifiers: e.modifiers,
        price: e.price,
        note: e.note,
        menuScreenId: e.menuScreenId,
        menuId: e.menuId
      };
    }) : [];
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => userInfo.id, JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo.storeId,
      checkHeaderId: seat.id,
      items,
      subtotalAmount
    };
    upsellCheck(dataToSend).then((resData) => {
      if (resData && resData.length > 0) {
        setIsUpsell(true);
        setSeat({
          ...check,
          ...resData,
          items: data
        });
      } else {
        goToCart();
      }
    }).catch((err) => {
      goToCart();
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handleCloseButton = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
  };

  // HTML CSS Code

  return (
    <>
      {props.loading && <Loader />}
      {isUpsell && <UpSell goToCart={goToCart} handleCloseButton={handleCloseButton} />}
    </>
  );
};

// Redux part

const mapStateToProps = ({
  orders,
  oauth
}) => ({
  seat: orders.seats,
  userInfo: oauth.loggedInUserData,
  deviceInfo: oauth.deviceInformation,
  loading: orders.isUpsellLoading
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  upsellCheck,
  setSeat,
  setNotification
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KioskUpsell);
